import React, {ReactElement} from "react"
import { Outlet} from "react-router-dom";

export function Management(): ReactElement {
  return (
    <Outlet/>
  )
}